(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arc-pet-scroll-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const stories = document.querySelectorAll('[data-arc-story]');
    stories.forEach((story) => {
      if (story.dataset.arcReady === 'true') return;
      story.dataset.arcReady = 'true';
      const chapters = [...story.querySelectorAll('[data-arc-chapter]')];
      const figures = [...story.querySelectorAll('[data-arc-figure]')];
      const paws = [...story.querySelectorAll('[data-arc-jump]')];
      const progress = story.querySelector('[data-arc-progress]');
      const stage = story.querySelector('.arc-story__stage');
      const visual = story.querySelector('[data-arc-visual]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const activate = (index) => {
        story.dataset.arcActive = String(index);
        chapters.forEach((chapter, chapterIndex) => chapter.classList.toggle('is-active', chapterIndex === index));
        figures.forEach((figure, figureIndex) => {
          const active = figureIndex === index;
          figure.classList.toggle('is-active', active);
          figure.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        paws.forEach((paw, pawIndex) => {
          paw.classList.toggle('is-active', pawIndex === index);
          if (pawIndex === index) paw.setAttribute('aria-current', 'step');
          else paw.removeAttribute('aria-current');
        });
        if (progress && chapters.length > 1) progress.style.height = `${(index / (chapters.length - 1)) * 100}%`;
      };

      paws.forEach((paw) => {
        paw.addEventListener('click', () => {
          const chapter = chapters[Number(paw.dataset.arcJump)];
          if (chapter) chapter.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        });
      });

      if (!('IntersectionObserver' in window)) {
        activate(0);
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible) activate(Number(visible.target.dataset.arcChapter));
      }, { rootMargin: '-28% 0px -28% 0px', threshold: [0, .2, .45, .7] });

      chapters.forEach((chapter) => observer.observe(chapter));
      let pinFrame = null;
      const updatePin = () => {
        pinFrame = null;
        if (!stage || !visual || window.matchMedia('(max-width: 989px)').matches) {
          if (visual) visual.style.removeProperty('--arc-pin-y');
          return;
        }
        const stageRect = stage.getBoundingClientRect();
        const maxTravel = Math.max(0, stageRect.height - window.innerHeight);
        const travel = Math.min(maxTravel, Math.max(0, -stageRect.top));
        visual.style.setProperty('--arc-pin-y', `${travel}px`);
      };
      const requestPin = () => {
        if (pinFrame !== null) return;
        pinFrame = window.requestAnimationFrame(updatePin);
      };
      window.addEventListener('scroll', requestPin, { passive: true });
      window.addEventListener('resize', requestPin);
      updatePin();
      activate(0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  // 頁腳三欄連結:HTML 預設 <details open> (冇 JS 都睇到晒);手機 (<750px) 收埋變 accordion,電腦永遠打開、撳標題唔會收。
  class ImFootMenus extends HTMLElement {
    connectedCallback() {
      if (this.mediaQuery) return;
      this.columns = Array.from(this.querySelectorAll('details.im-foot__col'));
      this.mediaQuery = window.matchMedia('(min-width: 750px)');
      this.sync = () => this.columns.forEach((column) => { column.open = this.mediaQuery.matches; });
      this.columns.forEach((column) => {
        column.querySelector('summary').addEventListener('click', (event) => {
          if (this.mediaQuery.matches) event.preventDefault();
        });
      });
      this.sync();
      if (this.mediaQuery.addEventListener) this.mediaQuery.addEventListener('change', this.sync);
    }
  }

  customElements.define('im-foot-menus', ImFootMenus);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => {
        if (typeof disclosure.close === 'function') disclosure.close();
      });
    }

    // details-modal.js 係 defer 載入：未行完（或者 FB/IG 內置瀏覽器載入失敗）時 <details-modal> 未有 close()，
    // 咁就直接收埋入面個 <details>
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (!this.searchModal) return;
      if (typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
        return;
      }
      const details = this.searchModal.querySelector('details');
      if (details) details.removeAttribute('open');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["im-mattress-fit"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
      root.classList.add('is-js');
      function select(i, focus) {
        tabs.forEach(function (t, j) {
          var on = i === j;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (panels[j]) panels[j].hidden = !on;
        });
        if (focus) tabs[i].focus();
        var strip = tabs[i].parentElement;
        if (strip && strip.scrollWidth > strip.clientWidth) {
          strip.scrollTo({ left: tabs[i].offsetLeft - 16, behavior: 'smooth' });
        }
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(i, false); });
        t.addEventListener('keydown', function (e) {
          var k = e.key;
          if (k !== 'ArrowRight' && k !== 'ArrowLeft') return;
          e.preventDefault();
          select((i + (k === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length, true);
        });
      });
      panels.forEach(function (p) { if (p.hasAttribute('data-hidden')) p.hidden = true; });
    }
    function all() { document.querySelectorAll('[data-im-mt-fit]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', all);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["im-mattress-layers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var slabs = root.querySelectorAll('.im-mt-layers__slab');
      var items = root.querySelectorAll('.im-mt-layers__item');
      function mark(i) {
        slabs.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-layer') === String(i)); });
      }
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          items.forEach(function (o) { if (o !== d) o.open = false; });
          mark(d.getAttribute('data-layer'));
        });
      });
      slabs.forEach(function (s) {
        s.addEventListener('click', function () {
          var d = root.querySelector('.im-mt-layers__item[data-layer="' + s.getAttribute('data-layer') + '"]');
          if (!d) return;
          d.open = true;
          if (window.matchMedia('(max-width: 989px)').matches) {
            d.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        });
      });
    }
    function all() { document.querySelectorAll('[data-im-mt-layers]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', all);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["im-mattress-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var cards = root.querySelectorAll('.im-mt-videos__card');
      var io = null;
      if (!reduce && 'IntersectionObserver' in window) {
        io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var card = en.target;
            var v = card.querySelector('video');
            if (en.intersectionRatio >= 0.6) {
              if (card.dataset.userPaused) return;
              var p = v.play();
              if (p && p.catch) p.catch(function () {});
            } else if (!v.paused) {
              v.pause();
            }
          });
        }, { threshold: [0, 0.6] });
      }
      cards.forEach(function (card) {
        var v = card.querySelector('video');
        v.addEventListener('play', function () { card.classList.add('is-playing'); });
        v.addEventListener('pause', function () { card.classList.remove('is-playing'); });
        card.querySelector('.im-mt-videos__hit').addEventListener('click', function () {
          if (v.paused) {
            delete card.dataset.userPaused;
            v.muted = false;
            v.play();
          } else if (v.muted) {
            v.muted = false;
          } else {
            card.dataset.userPaused = '1';
            v.pause();
          }
          card.classList.toggle('is-loud', !v.muted);
          cards.forEach(function (other) {
            if (other === card) return;
            var ov = other.querySelector('video');
            ov.muted = true;
            other.classList.remove('is-loud');
          });
        });
        if (io) io.observe(card);
      });
    }
    function all() { document.querySelectorAll('[data-im-mt-videos]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', all);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["living-room-collection-hero"]) return;
  try {
    
(function () {
  var allowedTypes = ['地櫃', '餐檯'];
  var observer;

  function filterMode() {
    var hero = document.querySelector('.im-living-hero');
    return hero ? hero.getAttribute('data-im-room-filter-mode') || 'client' : 'client';
  }

  function selectedRoomType() {
    var params = new URL(window.location.href).searchParams;
    var selected = params.get('filter.p.product_type') || params.get('room_type') || '';
    return allowedTypes.indexOf(selected) > -1 ? selected : '';
  }

  function productTypes() {
    var dataNode = document.getElementById('ImLivingProductTypeData');
    if (!dataNode) return {};

    try {
      return JSON.parse(dataNode.textContent).reduce(function (types, product) {
        types[product.handle] = product.type;
        return types;
      }, {});
    } catch (error) {
      return {};
    }
  }

  function productHandle(item) {
    var link = item.querySelector('a[href*="/products/"]');
    if (!link) return '';

    var match = link.getAttribute('href').match(/\/products\/([^?#]+)/);
    if (!match) return '';

    try {
      return decodeURIComponent(match[1]);
    } catch (error) {
      return match[1];
    }
  }

  function preserveRoomType(selected) {
    if (filterMode() === 'native') return;

    document.querySelectorAll('#FacetFiltersForm, #FacetFiltersFormMobile, #FacetSortForm').forEach(function (form) {
      var input = form.querySelector('input[name="room_type"]');

      if (!selected) {
        if (input) input.remove();
        return;
      }

      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'room_type';
        form.appendChild(input);
      }

      input.value = selected;
    });
  }

  function applyRoomFilter() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;

    var selected = selectedRoomType();
    var nativeMode = filterMode() === 'native';
    var types = nativeMode ? {} : productTypes();
    var visibleCount = 0;

    grid.querySelectorAll('.grid__item').forEach(function (item) {
      var visible = nativeMode || !selected || types[productHandle(item)] === selected;
      item.hidden = !visible;
      item.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (visible) visibleCount += 1;
    });

    document.querySelectorAll('[data-im-room-filter]').forEach(function (link) {
      var active = link.getAttribute('data-im-room-filter') === selected;
      link.classList.toggle('is-active', active);
      if (active) {
        link.setAttribute('aria-current', 'page');
      } else {
        link.removeAttribute('aria-current');
      }
    });

    document.querySelectorAll('#ProductCountDesktop, #ProductCount').forEach(function (count) {
      count.textContent = visibleCount + ' 項產品';
    });

    var status = document.getElementById('ImLivingFilterStatus');
    if (status) {
      status.textContent = selected ? '顯示 ' + visibleCount + ' 款' + selected : '顯示全部 ' + visibleCount + ' 款產品';
    }

    preserveRoomType(selected);
  }

  function filterWithTransition() {
    if (document.startViewTransition) {
      document.startViewTransition(applyRoomFilter);
    } else {
      applyRoomFilter();
    }
  }

  function handleFilterClick(event) {
    var link = event.target.closest('[data-im-room-filter]');
    if (!link || filterMode() === 'native' || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    event.preventDefault();

    var selected = link.getAttribute('data-im-room-filter') || '';
    var url = new URL(window.location.href);

    if (selected) {
      url.searchParams.set('room_type', selected);
    } else {
      url.searchParams.delete('room_type');
    }

    url.hash = 'ProductGridContainer';
    window.history.pushState({}, '', url);
    filterWithTransition();

    var grid = document.getElementById('ProductGridContainer');
    if (grid) {
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      grid.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    }
  }

  function observeProductGrid() {
    var container = document.getElementById('ProductGridContainer');
    if (!container || observer) return;

    observer = new MutationObserver(function (mutations) {
      var gridChanged = mutations.some(function (mutation) {
        return mutation.type === 'childList';
      });

      if (gridChanged) {
        window.requestAnimationFrame(applyRoomFilter);
      }
    });

    observer.observe(container, { childList: true, subtree: true });
  }

  function initializeRoomFilter() {
    applyRoomFilter();
    observeProductGrid();
  }

  document.addEventListener('click', handleFilterClick);
  window.addEventListener('popstate', filterWithTransition);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeRoomFilter, { once: true });
  } else {
    initializeRoomFilter();
  }

  document.addEventListener('shopify:section:load', initializeRoomFilter);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-policy-page"]) return;
  try {
    
  class ImPolicyAside extends HTMLElement {
    connectedCallback() {
      // 手機：而家嗰頁嘅 chip 碌入畫面
      const current = this.querySelector('.im-policy__nav [aria-current="page"]');
      if (current) {
        const row = current.closest('ul');
        row.scrollLeft = current.parentElement.offsetLeft - row.clientWidth / 2 + current.offsetWidth / 2;
      }

      // 電腦：由內文 h2 生「本頁內容」，3 個或以上先出
      const toc = this.querySelector('.im-policy__toc');
      const body = this.closest('.im-policy') && this.closest('.im-policy').querySelector('.im-policy__body');
      if (!toc || !body) return;
      const headings = body.querySelectorAll(':scope > h2');
      if (headings.length < 3) return;
      const list = toc.querySelector('ol');
      const used = new Set();
      headings.forEach((heading) => {
        let id = heading.id || heading.textContent.trim().replace(/\s+/g, '-');
        while (used.has(id) || (document.getElementById(id) && document.getElementById(id) !== heading)) id += '-';
        used.add(id);
        heading.id = id;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = '#' + id;
        link.textContent = heading.textContent.trim();
        item.appendChild(link);
        list.appendChild(item);
      });
      toc.hidden = false;
    }
  }

  if (!customElements.get('im-policy-aside')) customElements.define('im-policy-aside', ImPolicyAside);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product_bak_m360_20220217_065643"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moon-pet-scroll-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const stories = document.querySelectorAll('[data-moon-scroll-story]');

    stories.forEach((story) => {
      if (story.dataset.moonReady === 'true') return;
      story.dataset.moonReady = 'true';

      const chapters = Array.from(story.querySelectorAll('[data-moon-chapter]'));
      const visuals = Array.from(story.querySelectorAll('[data-moon-visual]'));
      const steps = Array.from(story.querySelectorAll('[data-moon-step]'));
      const progress = story.querySelector('[data-moon-progress]');
      const stage = story.querySelector('.moon-story__stage');
      const experience = story.querySelector('.moon-story__experience');
      const effects = Array.from(story.querySelectorAll('[data-moon-fx]'));
      const doorComposites = Array.from(story.querySelectorAll('[data-moon-door-composite]'));
      const slidingChapter = story.querySelector('.moon-story__chapter--sliding_door');
      const counter = story.querySelector('[data-moon-counter]');
      const trail = Array.from(story.querySelectorAll('[data-moon-trail] i'));
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let trailIndex = 0;
      let lastTrailAt = 0;
      let scrollFrame = 0;
      let stageMetrics = null;

      if (!chapters.length) return;

      const activate = (index) => {
        chapters.forEach((chapter, itemIndex) => chapter.classList.toggle('is-active', itemIndex === index));
        visuals.forEach((visual, itemIndex) => visual.classList.toggle('is-active', itemIndex === index));
        steps.forEach((step, itemIndex) => step.classList.toggle('is-active', itemIndex === index));
        effects.forEach((effect, itemIndex) => effect.classList.toggle('is-active', itemIndex === index));
        story.dataset.moonActive = String(index);
        if (counter) counter.textContent = String(index + 1).padStart(2, '0');
        if (progress) progress.style.height = `${((index + 1) / chapters.length) * 100}%`;
      };

      const markSeen = () => {
        if (!('IntersectionObserver' in window) || reducedMotion) {
          chapters.forEach((chapter) => chapter.classList.add('is-seen'));
          return;
        }

        const revealObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-seen');
            revealObserver.unobserve(entry.target);
          });
        }, { threshold: .18 });

        chapters.forEach((chapter) => revealObserver.observe(chapter));
      };

      if (stage && !reducedMotion) {
        stage.addEventListener('pointermove', (event) => {
          const rect = stage.getBoundingClientRect();
          const x = Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width));
          const y = Math.max(0, Math.min(1, (event.clientY - rect.top) / rect.height));
          story.style.setProperty('--moon-rx', `${((.5 - y) * 3.2).toFixed(2)}deg`);
          story.style.setProperty('--moon-ry', `${((x - .5) * 4.2).toFixed(2)}deg`);

          const now = performance.now();
          if (!trail.length || now - lastTrailAt < 85) return;
          lastTrailAt = now;
          const dot = trail[trailIndex % trail.length];
          trailIndex += 1;
          const effectsRect = story.querySelector('[data-moon-effects]')?.getBoundingClientRect();
          if (!effectsRect) return;
          dot.style.left = `${event.clientX - effectsRect.left}px`;
          dot.style.top = `${event.clientY - effectsRect.top}px`;
          dot.classList.remove('is-popping');
          void dot.offsetWidth;
          dot.classList.add('is-popping');
        });

        stage.addEventListener('pointerleave', () => {
          story.style.setProperty('--moon-rx', '0deg');
          story.style.setProperty('--moon-ry', '0deg');
        });
      }

      const updateContinuousScroll = () => {
        scrollFrame = 0;
        if (!experience) return;
        const rect = experience.getBoundingClientRect();
        const distance = Math.max(1, rect.height - window.innerHeight);
        const ratio = Math.max(0, Math.min(1, -rect.top / distance));
        story.style.setProperty('--moon-sway', reducedMotion ? '0px' : `${((ratio - .5) * -22).toFixed(1)}px`);
        story.style.setProperty('--moon-velocity', ratio.toFixed(3));

        const viewportMidpoint = window.innerHeight * .5;
        let nearestChapterIndex = 0;
        let nearestChapterDistance = Number.POSITIVE_INFINITY;
        chapters.forEach((chapter, index) => {
          const chapterRect = chapter.getBoundingClientRect();
          const chapterDistance = chapterRect.top <= viewportMidpoint && chapterRect.bottom >= viewportMidpoint
            ? 0
            : Math.min(Math.abs(chapterRect.top - viewportMidpoint), Math.abs(chapterRect.bottom - viewportMidpoint));
          if (chapterDistance < nearestChapterDistance) {
            nearestChapterDistance = chapterDistance;
            nearestChapterIndex = index;
          }
        });
        if (story.dataset.moonActive !== String(nearestChapterIndex)) activate(nearestChapterIndex);

        if (slidingChapter && doorComposites.length) {
          let visibleDoorProgress = 0;
          doorComposites.forEach((doorComposite) => {
            const mobileDriver = doorComposite.closest('.moon-story__mobile-door-demo');
            const doorDriver = mobileDriver || slidingChapter;
            const doorRect = doorDriver.getBoundingClientRect();
            const doorTravel = Math.max(1, window.innerHeight * .72);
            const rawDoorProgress = Math.max(0, Math.min(1, (window.innerHeight * .5 - doorRect.top) / doorTravel));
            const smoothDoorProgress = reducedMotion
              ? (rawDoorProgress >= .5 ? 1 : 0)
              : rawDoorProgress * rawDoorProgress * (3 - 2 * rawDoorProgress);
            const doorGlow = Math.sin(Math.PI * smoothDoorProgress);
            const doorShift = doorComposite.clientWidth * .376 * smoothDoorProgress;
            const doorGuide = 31.2 + 37.6 * smoothDoorProgress;

            doorComposite.dataset.moonDoorProgress = smoothDoorProgress.toFixed(3);
            doorComposite.style.setProperty('--moon-door-x', `${doorShift.toFixed(2)}px`);
            doorComposite.style.setProperty('--moon-door-guide-x', `${doorGuide.toFixed(2)}%`);
            doorComposite.style.setProperty('--moon-door-glow', doorGlow.toFixed(3));
            doorComposite.style.setProperty('--moon-door-brightness', (.98 + doorGlow * .06).toFixed(3));
            doorComposite.style.setProperty('--moon-door-saturation', (.96 + doorGlow * .12).toFixed(3));
            doorComposite.style.setProperty('--moon-door-sweep-opacity', (.18 + doorGlow * .82).toFixed(3));
            doorComposite.style.setProperty('--moon-door-rail-opacity', (.22 + doorGlow * .62).toFixed(3));
            if (doorComposite.getBoundingClientRect().width > 0) visibleDoorProgress = smoothDoorProgress;
          });
          story.dataset.moonDoorProgress = visibleDoorProgress.toFixed(3);
        }

        if (!stage || window.innerWidth < 990) {
          stage?.classList.remove('is-moon-fixed');
          if (stage) {
            stage.style.removeProperty('position');
            stage.style.removeProperty('left');
            stage.style.removeProperty('top');
            stage.style.removeProperty('width');
            stage.style.removeProperty('z-index');
          }
          stageMetrics = null;
          return;
        }

        if (!stageMetrics || stageMetrics.viewportWidth !== window.innerWidth) {
          stage.classList.remove('is-moon-fixed');
          const natural = stage.getBoundingClientRect();
          stageMetrics = {
            left: natural.left,
            width: natural.width,
            height: window.innerHeight * .86,
            viewportWidth: window.innerWidth
          };
        }

        const preferredTop = window.innerHeight * .07;
        const shouldPin = rect.top <= preferredTop && rect.bottom > 0;
        if (!shouldPin) {
          stage.classList.remove('is-moon-fixed');
          stage.style.removeProperty('position');
          stage.style.removeProperty('left');
          stage.style.removeProperty('top');
          stage.style.removeProperty('width');
          stage.style.removeProperty('z-index');
          return;
        }

        const fixedTop = Math.min(preferredTop, rect.bottom - stageMetrics.height);
        story.style.setProperty('--moon-fixed-left', `${stageMetrics.left.toFixed(1)}px`);
        story.style.setProperty('--moon-fixed-width', `${stageMetrics.width.toFixed(1)}px`);
        story.style.setProperty('--moon-fixed-top', `${fixedTop.toFixed(1)}px`);
        stage.classList.add('is-moon-fixed');
        stage.style.position = 'fixed';
        stage.style.left = `${stageMetrics.left.toFixed(1)}px`;
        stage.style.top = `${fixedTop.toFixed(1)}px`;
        stage.style.width = `${stageMetrics.width.toFixed(1)}px`;
        stage.style.zIndex = '5';
      };

      const scheduleContinuousScroll = () => {
        if (scrollFrame) return;
        scrollFrame = requestAnimationFrame(updateContinuousScroll);
      };

      window.addEventListener('scroll', scheduleContinuousScroll, { passive: true });
      window.addEventListener('resize', scheduleContinuousScroll, { passive: true });
      markSeen();
      scheduleContinuousScroll();

      steps.forEach((step, index) => {
        step.addEventListener('click', () => {
          chapters[index]?.scrollIntoView({
            behavior: reducedMotion ? 'auto' : 'smooth',
            block: 'center'
          });
        });
      });

      if (!('IntersectionObserver' in window) || reducedMotion) {
        activate(0);
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

        if (!visible) return;
        activate(Number(visible.target.dataset.moonChapter));
      }, {
        rootMargin: '-28% 0px -32% 0px',
        threshold: [0.15, 0.35, 0.55, 0.75]
      });

      chapters.forEach((chapter) => observer.observe(chapter));
      activate(0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["playground-pet-scroll-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const stories = document.querySelectorAll('[data-playground-scroll-story]');

    stories.forEach((story) => {
      if (story.dataset.playgroundReady === 'true') return;
      story.dataset.playgroundReady = 'true';

      const chapters = Array.from(story.querySelectorAll('[data-playground-chapter]'));
      const visuals = Array.from(story.querySelectorAll('[data-playground-visual]'));
      const steps = Array.from(story.querySelectorAll('[data-playground-step]'));
      const progress = story.querySelector('[data-playground-progress]');
      const stage = story.querySelector('.playground-story__stage');
      const experience = story.querySelector('.playground-story__experience');
      const effects = Array.from(story.querySelectorAll('[data-playground-fx]'));
      const counter = story.querySelector('[data-playground-counter]');
      const trail = Array.from(story.querySelectorAll('[data-playground-trail] i'));
      const doorChapter = story.querySelector('.playground-story__chapter--sliding_door');
      const continueButton = story.querySelector('[data-playground-continue]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let trailIndex = 0;
      let lastTrailAt = 0;
      let scrollFrame = 0;
      let stageMetrics = null;

      if (!chapters.length) return;

      const activate = (index) => {
        chapters.forEach((chapter, itemIndex) => chapter.classList.toggle('is-active', itemIndex === index));
        visuals.forEach((visual, itemIndex) => visual.classList.toggle('is-active', itemIndex === index));
        steps.forEach((step, itemIndex) => step.classList.toggle('is-active', itemIndex === index));
        effects.forEach((effect, itemIndex) => effect.classList.toggle('is-active', itemIndex === index));
        story.dataset.playgroundActive = String(index);
        if (counter) counter.textContent = String(index + 1).padStart(2, '0');
        if (progress) progress.style.height = `${((index + 1) / chapters.length) * 100}%`;
      };

      const markSeen = () => {
        if (!('IntersectionObserver' in window) || reducedMotion) {
          chapters.forEach((chapter) => chapter.classList.add('is-seen'));
          return;
        }

        const revealObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-seen');
            revealObserver.unobserve(entry.target);
          });
        }, { threshold: .18 });

        chapters.forEach((chapter) => revealObserver.observe(chapter));
      };

      if (stage && !reducedMotion) {
        stage.addEventListener('pointermove', (event) => {
          const rect = stage.getBoundingClientRect();
          const x = Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width));
          const y = Math.max(0, Math.min(1, (event.clientY - rect.top) / rect.height));
          story.style.setProperty('--playground-rx', `${((.5 - y) * 3.2).toFixed(2)}deg`);
          story.style.setProperty('--playground-ry', `${((x - .5) * 4.2).toFixed(2)}deg`);

          const now = performance.now();
          if (!trail.length || now - lastTrailAt < 85) return;
          lastTrailAt = now;
          const dot = trail[trailIndex % trail.length];
          trailIndex += 1;
          const effectsRect = story.querySelector('[data-playground-effects]')?.getBoundingClientRect();
          if (!effectsRect) return;
          dot.style.left = `${event.clientX - effectsRect.left}px`;
          dot.style.top = `${event.clientY - effectsRect.top}px`;
          dot.classList.remove('is-popping');
          void dot.offsetWidth;
          dot.classList.add('is-popping');
        });

        stage.addEventListener('pointerleave', () => {
          story.style.setProperty('--playground-rx', '0deg');
          story.style.setProperty('--playground-ry', '0deg');
        });
      }

      const updateContinuousScroll = () => {
        scrollFrame = 0;
        if (!experience) return;
        const rect = experience.getBoundingClientRect();
        const distance = Math.max(1, rect.height - window.innerHeight);
        const ratio = Math.max(0, Math.min(1, -rect.top / distance));
        story.style.setProperty('--playground-sway', reducedMotion ? '0px' : `${((ratio - .5) * -22).toFixed(1)}px`);
        story.style.setProperty('--playground-velocity', ratio.toFixed(3));

        if (doorChapter) {
          const doorRect = doorChapter.getBoundingClientRect();
          const isMobileDoor = window.innerWidth < 990;
          const doorStart = window.innerHeight * (isMobileDoor ? .9 : .34);
          const doorEnd = window.innerHeight * (isMobileDoor ? .15 : -.74);
          const doorDistance = Math.max(1, doorStart - doorEnd);
          const doorProgress = reducedMotion ? 1 : Math.max(0, Math.min(1, (doorStart - doorRect.top) / doorDistance));
          let doorLeft = 0;
          let doorRight = 0;
          let doorState = 'closed';

          if (doorProgress > .3 && doorProgress < .5) {
            const openRightProgress = (doorProgress - .3) / .2;
            doorRight = -40 * openRightProgress;
            doorState = 'opening-right';
          } else if (doorProgress >= .5 && doorProgress <= .6) {
            doorRight = -40;
            doorState = 'right-open';
          } else if (doorProgress > .6 && doorProgress < .78) {
            const openLeftProgress = (doorProgress - .6) / .18;
            doorRight = -40 * (1 - openLeftProgress);
            doorLeft = 40 * openLeftProgress;
            doorState = 'opening-left';
          } else if (doorProgress >= .78) {
            doorLeft = 40;
            doorState = 'left-open';
          }

          story.style.setProperty('--playground-door-left', `${doorLeft.toFixed(2)}%`);
          story.style.setProperty('--playground-door-right', `${doorRight.toFixed(2)}%`);
          story.dataset.playgroundDoor = doorProgress.toFixed(3);
          story.dataset.playgroundDoorState = doorState;
        }

        if (!stage || window.innerWidth < 990) {
          stage?.classList.remove('is-playground-fixed');
          stageMetrics = null;
          return;
        }

        if (!stageMetrics || stageMetrics.viewportWidth !== window.innerWidth) {
          stage.classList.remove('is-playground-fixed');
          const natural = stage.getBoundingClientRect();
          stageMetrics = {
            left: natural.left,
            width: natural.width,
            height: window.innerHeight * .86,
            viewportWidth: window.innerWidth
          };
        }

        const preferredTop = window.innerHeight * .07;
        const shouldPin = rect.top <= preferredTop && rect.bottom > 0;
        if (!shouldPin) {
          stage.classList.remove('is-playground-fixed');
          return;
        }

        const fixedTop = Math.min(preferredTop, rect.bottom - stageMetrics.height);
        story.style.setProperty('--playground-fixed-left', `${stageMetrics.left.toFixed(1)}px`);
        story.style.setProperty('--playground-fixed-width', `${stageMetrics.width.toFixed(1)}px`);
        story.style.setProperty('--playground-fixed-top', `${fixedTop.toFixed(1)}px`);
        stage.classList.add('is-playground-fixed');
      };

      const scheduleContinuousScroll = () => {
        if (scrollFrame) return;
        scrollFrame = requestAnimationFrame(updateContinuousScroll);
      };

      window.addEventListener('scroll', scheduleContinuousScroll, { passive: true });
      window.addEventListener('resize', scheduleContinuousScroll, { passive: true });
      markSeen();
      scheduleContinuousScroll();

      steps.forEach((step, index) => {
        step.addEventListener('click', () => {
          chapters[index]?.scrollIntoView({
            behavior: reducedMotion ? 'auto' : 'smooth',
            block: 'center'
          });
        });
      });

      continueButton?.addEventListener('click', () => {
        let nextSection = story.closest('.shopify-section')?.nextElementSibling;

        while (nextSection) {
          const nextStyles = window.getComputedStyle(nextSection);
          const nextHeight = nextSection.getBoundingClientRect().height;

          if (nextStyles.display !== 'none' && nextStyles.visibility !== 'hidden' && nextHeight > 1) break;
          nextSection = nextSection.nextElementSibling;
        }

        nextSection?.scrollIntoView({
          behavior: reducedMotion ? 'auto' : 'smooth',
          block: 'start'
        });
      });

      if (!('IntersectionObserver' in window) || reducedMotion) {
        activate(0);
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

        if (!visible) return;
        activate(Number(visible.target.dataset.playgroundChapter));
      }, {
        rootMargin: '-28% 0px -32% 0px',
        threshold: [0.15, 0.35, 0.55, 0.75]
      });

      chapters.forEach((chapter) => observer.observe(chapter));
      activate(0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sofabed-size-checker"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function collectMatches(text, pattern, divisor, values) {
      var match;
      pattern.lastIndex = 0;

      while ((match = pattern.exec(text)) !== null) {
        var number = Number(match[1]);
        if (!number) continue;
        if (divisor) number = number / divisor;
        if (number >= 70 && number <= 320) values.push(number);
      }
    }

    function parseWidth(text) {
      var values = [];
      var source = String(text || '').replace(/&nbsp;/g, ' ');

      collectMatches(source, /(\d+(?:\.\d+)?)\s*(?:cm|厘米|公分)/gi, 1, values);
      collectMatches(source, /(\d+(?:\.\d+)?)\s*(?:mm|毫米)/gi, 10, values);

      if (!values.length) {
        collectMatches(source, /(\d+(?:\.\d+)?)/g, 1, values);
      }

      if (!values.length) return 0;

      return Math.round(
        values.reduce(function (smallest, value) {
          return Math.min(smallest, value);
        }, values[0])
      );
    }

    function sortItems(items) {
      return items.sort(function (a, b) {
        var aRank = a.classList.contains('is-fit') ? 0 : a.classList.contains('is-unknown') ? 2 : 1;
        var bRank = b.classList.contains('is-fit') ? 0 : b.classList.contains('is-unknown') ? 2 : 1;
        var aWidth = Number(a.getAttribute('data-min-width')) || 999;
        var bWidth = Number(b.getAttribute('data-min-width')) || 999;

        if (aRank !== bRank) return aRank - bRank;
        return aWidth - bWidth;
      });
    }

    function update(root) {
      var range = root.querySelector('[data-size-range]');
      var value = root.querySelector('[data-size-value]');
      var status = root.querySelector('[data-size-status]');
      var summary = root.querySelector('[data-size-summary]');
      var list = root.querySelector('[data-size-list]');
      var width = Number(range.value);
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-size-item]'));
      var fitCount = 0;
      var unknownCount = 0;

      value.textContent = width + ' cm';

      items.forEach(function (item) {
        var min = Number(item.getAttribute('data-min-width'));
        var pill = item.querySelector('[data-size-pill]');

        if (!item.hasAttribute('data-width-ready')) {
          min = parseWidth(item.getAttribute('data-width-text'));
          item.setAttribute('data-min-width', min || '');
          item.setAttribute('data-width-ready', 'true');
        }

        if (!min) {
          item.classList.remove('is-fit');
          item.classList.add('is-unknown');
          pill.textContent = '睇尺寸表';
          unknownCount += 1;
          return;
        }

        var fit = width >= min;
        item.classList.toggle('is-fit', fit);
        item.classList.remove('is-unknown');
        pill.textContent = fit ? '放得落' : '差 ' + (min - width) + 'cm';
        if (fit) fitCount += 1;
      });

      sortItems(items).forEach(function (item) {
        list.appendChild(item);
      });

      status.textContent =
        fitCount + ' 款放得落你嘅 ' + width + 'cm' + (unknownCount ? '，另有 ' + unknownCount + ' 款要睇尺寸表' : '');
      summary.textContent = fitCount ? fitCount + ' 款可能放得落' : '睇邊幾款放得落';
    }

    function init(root) {
      if (!root || root.hasAttribute('data-size-check-ready')) return;
      root.setAttribute('data-size-check-ready', 'true');

      var range = root.querySelector('[data-size-range]');
      if (!range) return;

      range.addEventListener('input', function () {
        update(root);
      });

      update(root);
    }

    function initAll() {
      document.querySelectorAll('[data-sofabed-size-check]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target.querySelector('[data-sofabed-size-check]'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
